import React from 'react'
import { Marker } from 'react-mapbox-gl'
import { connect } from 'react-redux'
import { array } from 'prop-types'
import { getStreetViewImage } from '../../../store/Actions/SignsActions'
import Image from '../../../assets/img/pin2.png'

const SearchMarker = ({
  center,
  address,
  signs,
  addressBasedSearch,
  getStreetViewImage,
}) =>
  signs &&
  addressBasedSearch && (
    <Marker coordinates={center} anchor="bottom">
      <img
        onMouseEnter={() => getStreetViewImage([center[1], center[0]])}
        src={Image}
        alt={address}
        title={address}
        className="activeMarker"
      />
    </Marker>
  )

SearchMarker.propTypes = {
  center: array.isRequired,
}

const mapStateToProps = ({ map, signsState }) => ({
  center: map.cache.center,
  address: signsState.addressCache,
  signs: signsState.signs.length > 0,
  addressBasedSearch: map.addressBasedSearch,
})

const actions = {
  getStreetViewImage,
}

export default connect(
  mapStateToProps,
  actions
)(SearchMarker)



// WEBPACK FOOTER //
// ./src/components/Map/Markers/SearchMarker.jsx